exports.APIS = {
  Auth: "/common/auth/login",

  Dashboard: "/admin/dashboard/dashboard-data",
  Download: "/admin/dashboard/download",
  Wallet: {
    history: "/admin/wallet/history",
    WithdrawReq: "/admin/wallet",
    FundReq: "/admin/wallet/fund-request",
  },
  Banks: {
    Banks: "/admin/banks",
    BanksHistory: "/admin/banks/history",
  },
  Masters: {
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    District: "/admin/masters/district",
    Taluka: {
      CRUD: "/admin/masters/taluka",
      Available: "/admin/masters/taluka-available",
    },
    App_Setup: "/admin/masters/app-setup",
    HomeBanner: "/admin/masters/home-banners",
    OffersEvents: "/admin/masters/offers-events",
    Categories: {
      CRUD: "/admin/masters/categories",
      TopCategory: "/admin/masters/categories/top-category",
    },
    PaymentMethod: "/admin/masters/payment-methods",
  },

  // common
  Commons: {
    AllRoles: "/common/masters/all-roles",
    AllPermmission: "/common/masters/all-permission",
    Country: "/common/masters/all-country",
    State: "/common/masters/all-state",
    District: "/common/masters/all-district",
    Taluka: "/common/masters/all-taluka",
    Categories: "/common/masters/all-categories",
    BankPaymentType: "/common/masters/all-bank-payment-type",
    OrderPaymentType: "/common/masters/all-order-payment-type",
    StateDistrict: "/common/masters/all-state-district",
    BankStatus: "/common/masters/all-bank-status",
    ApprovalBankStatus: "/common/masters/all-approval-bank-status",
    AllPolicyType: "/common/masters/all-policy-type",
    AllOrderStatus: "/common/masters/all-order-status",
    AllPaymentStatus: "/common/masters/all-payment-status",
    AllARPaymentStatus: "/common/masters/all-ar-payment-status",
    AllBanks: "/common/masters/all-banks",
    AllTicketStatus: "/common/masters/all-ticket-status",
    AllWalletType: "/common/masters/all-wallet-type",
    AllSellStatus: "/common/masters/all-sell-status",
    AllARSellStatus: "/common/masters/all-ar-sell-status",
    AllCORequestType: "/common/masters/all-co-request-type",
    KycStatus: "/common/masters/all-kyc-status",
    ApprovalkycStatus: "/common/masters/all-approval-kyc-status",
  },

  //product Manage
  Products: {
    InvestorProduct: {
      CRUD: "/admin/products/investor-products",
      Populer: "/admin/products/investor-products/populer",
      Recommended: "/admin/products/investor-products/recommended",
    },
    ClientProduct: {
      CRUD: "/admin/products/client-products",
      Populer: "/admin/products/client-products/populer",
      Recommended: "/admin/products/client-products/recommended",
    },
  },

  UserManagement: {
    Roles: "/admin/roles",
    Employees: "/admin/roles/employees",
    Owner: "/admin/customer-management/customer",
  },

  Management: {
    Investors: "/admin/management/investors",
    InvestorsDownload: {
      Excel: "/admin/management/investors/download-excel",
    },
    InvestorsBank: "/admin/management/investors/bank",
    InvestorsKycVerification: "/admin/management/investors/kyc-verification",
    InvestorsBankHistory: "/admin/management/investors/bank-history",
    Clients: "/admin/management/clients",
    ClientsDownload: {
      Excel: "/admin/management/clients/download-excel",
    },
    ClientsBank: "/admin/management/clients/bank",
    ClientsKycVerification: "/admin/management/clients/kyc-verification",
    ClientsBankHistory: "/admin/management/clients/bank-history",
  },

  Policy: {
    Policy: "/admin/policy/policy",
    FollowUs: "/admin/policy/follow-us",
    AboutUs: "/admin/policy/about-us",
  },

  Orders: {
    InvestorOrders: {
      CRUD: "/admin/orders/investor-orders",
    },
    InvestorWalletOrders: {
      CRUD: "/admin/orders/investor-wallet-orders",
    },
    ClientOrders: {
      CRUD: "/admin/orders/client-orders",
    },
    ClientWalletOrders: {
      CRUD: "/admin/orders/client-wallet-orders",
      RenewOrder: "/admin/orders/client-wallet-renew-orders",
    },
  },
  SellOrders: {
    InvestorSellOrders: {
      CRUD: "/admin/sell-orders/investor-sell-orders",
    },
    InvestorAllSellOrders: {
      CRUD: "/admin/sell-orders/investor-all-sell-orders",
    },
  },
  WalletManagement: {
    WalletHistory: {
      CRUD: "/admin/wallet/wallet-history",
      Export: "/admin/wallet/wallet-history-export",
    },
    Payments: {
      CRUD: "/admin/wallet/payments",
      Export: "/admin/wallet/payments-export",
    },
    PaymentWithdrawal: {
      CRUD: "/admin/wallet/payments-withdrawal",
      Export: "/admin/wallet/payments-withdrawal-export",
    },
  },

  TicketManagement: {
    Subjects: "/admin/tickets-management/subjects",
    TicketManagement: {
      CRUD: "/admin/tickets-management/tickets-management",
    },
  },

  NotificationsManagement: {
    Notifications: "/admin/notifications/notifications",
  },
};
